"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColorStyle = function (_a) {
    var backgroundColor = _a.backgroundColor, fontColor = _a.fontColor, borderColor = _a.borderColor;
    var classNames = [];
    var style = {};
    if (typeof backgroundColor === "string") {
        style.backgroundColor = backgroundColor;
    }
    else if (backgroundColor && typeof backgroundColor === "object") {
        classNames.push(backgroundColor.backgroundClassName);
    }
    if (typeof fontColor === "string") {
        style.color = fontColor;
    }
    else if (fontColor && typeof fontColor === "object") {
        classNames.push(fontColor.fontClassName);
    }
    if (typeof borderColor === "string") {
        style.borderColor = borderColor;
    }
    else if (borderColor && typeof borderColor === "object") {
        classNames.push(borderColor.borderClassName);
    }
    return [classNames, style];
};
